/**
 * Utility functions for className management
 * 
 * @module utils/cn
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind CSS classes with proper precedence handling
 * 
 * @param inputs - Class values to merge
 * @returns Merged className string
 * 
 * @example
 * ```tsx
 * cn('px-4 py-2', 'hover:bg-primary', isActive && 'bg-primary')
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Generates navbar link classes based on homepage status
 * 
 * @param isHomePage - Whether the current page is the homepage
 * @returns Conditional className string
 * 
 * @example
 * ```tsx
 * <Link className={navLinkClass(isHomePage)}>Home</Link>
 * ```
 */
export function navLinkClass(_isHomePage?: boolean): string {
  return cn(
    'px-1 py-2 font-medium transition-all duration-300',
    'text-foreground hover:text-primary'
  );
}
